import { DataProxy, InMemoryCache, InMemoryCacheConfig } from "@apollo/client";
import cloneDeep from "lodash/cloneDeep";

/**
 * The cache-update functions were written for Apollo Client 2: they read a query, change the result in place and
 * write it back. Apollo Client 3 shares (and in development freezes) the objects it returns, so reads hand out
 * copies that can be changed safely.
 */
export class MutableResultCache extends InMemoryCache {
  constructor(config: InMemoryCacheConfig = {}) {
    super({
      // Every Upkeepr entity has a globally unique Id; objects without one stay embedded in their parent.
      dataIdFromObject: (object: any) => object.Id || undefined,
      ...config,
    });
  }

  readQuery<QueryType, TVariables = any>(
    options: DataProxy.Query<TVariables, QueryType>,
    optimistic?: boolean,
  ): QueryType | null {
    const result = super.readQuery<QueryType, TVariables>(options, optimistic);
    return result == null ? result : cloneDeep(result);
  }

  readFragment<FragmentType, TVariables = any>(
    options: DataProxy.Fragment<TVariables, FragmentType>,
    optimistic?: boolean,
  ): FragmentType | null {
    const result = super.readFragment<FragmentType, TVariables>(options, optimistic);
    return result == null ? result : cloneDeep(result);
  }
}
